import * as React from 'react';

export interface HeaderProps {
  headerText: string;
  version: string;
  Logo: React.ComponentType;
  HeaderUtilities?: React.FC;
}

const Header = ({
  Logo,
  headerText,
  version,
  HeaderUtilities,
}: HeaderProps): JSX.Element => (
  <div className="site-header__utility">
    <div>
      <div className="site-header__logo">
        <Logo />
      </div>
      <div className="app-name__container">
        <div className="u-text-uppercase app-name__text" data-toggle="tooltip" title={version}>
          {headerText}
        </div>
      </div>
    </div>
    <div className="u-text-right">
      {HeaderUtilities && <HeaderUtilities />}
    </div>
  </div>
);

export default Header;
